import { Component } from '@angular/core';
import {AppConfig} from "../constants";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {Title} from "@angular/platform-browser";
import {ActivatedRoute, NavigationEnd, Router, RouterState} from "@angular/router";
import {FacebookService, LoginResponse} from "ng2-facebook-sdk";

import * as moment from 'moment';
import "moment/locale/ru";
import "moment/locale/ro";

declare var window: any;
declare var FB: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  public title = 'app';

  constructor(
    private fb: FacebookService,
    private translate: TranslateService,
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute
  ){
    this.translate.addLangs(["en", "ro", "ru"]);
    this.translate.setDefaultLang('ru');

    let browserLang = translate.getBrowserLang();
    let useLang = browserLang.match(/en|ro|ru/) ? browserLang : 'en';
    this.translate.use(useLang);
    // moment.locale('ru' || useLang);

    this.fb.init(AppConfig.fbInitParams).then(()=>{
       FB.AppEvents.logPageView();
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // this.updatePageTitle(event);
        // this.setLanguage();
        window.scrollTo(0,0);
        const title = this.getTitle(
          router.routerState,
          router.routerState.root
        );
        titleService.setTitle(title[title.length - 1]);
      }
    });

    // this.translate.onLangChange.subscribe((language)=>{
    //   this.setLocation(language.lang);
    // });
  }
  //
  // public updatePageTitle(e) {
  //   this.titleService.getTitle();
  // }

  public getTitle(state: RouterState, parent: ActivatedRoute | null): Array<string> {
    const data: Array<string> = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }
    if (state && parent) {
      data.push(...this.getTitle(state, parent.firstChild));
    }
    return data;
  }

  // public setLanguage(){
  //   let lang = this.router.url.split('/')[1];
  //   if( lang !== this.translate.currentLang) {
  //     this.translate.use(lang);
  //   }
  // }

  // public setLocation(lang){
  //   let routerSteps = this.router.url.split('/');
  //   routerSteps[1] = lang;
  //   window.scrollTo(0,0);
  //   this.router.navigate([routerSteps.join('/')], {});
  // }

}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/app.component.ts